// Pure-math helpers used by Deals card chips, the New/Edit form's auto-fields,
// and the pipeline summary. Kept dependency-free so the same code paths can
// be reused in tests or other deal-adjacent components.

export function fmtUSD0(n) {
  if (n == null || n === "") return "—";
  return `$${Number(n).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function pct(n) {
  if (n == null || n === "") return "—";
  return `${Number(n).toFixed(2)}%`;
}

/** Standard mortgage formula. Returns 0 if any input is missing/invalid.
 *  Amortizing: P · r(1+r)^n / ((1+r)^n − 1)
 *  Interest-only: P · r (monthly interest only, no principal amortization)
 *  r = annual_rate / 12 / 100, n = years × 12
 */
export function calcMonthlyPayment({ principal, annualRatePct, termYears, loanType }) {
  const P = Number(principal);
  const r = Number(annualRatePct) / 100 / 12;
  const n = Math.max(Math.round(Number(termYears) * 12), 0);
  if (!P || P <= 0 || r < 0 || !n) return 0;
  if (loanType === "interest_only") return P * r;
  if (r === 0) return P / n;
  const f = Math.pow(1 + r, n);
  return (P * (r * f)) / (f - 1);
}
